export const isProdNodeEnv = process.env.NODE_ENV === 'production';
export const isLocalNodeEnv = process.env.NODE_ENV === 'development';

export const isProd = process.env.NEXT_PUBLIC_ENV === 'prod';
export const isStage = process.env.NEXT_PUBLIC_ENV === 'stage';
export const isDev = process.env.NEXT_PUBLIC_ENV === 'dev';

export const isGitlabCI =
  process.env.CI === 'true' ||
  process.env.GITHUB_ACTIONS === 'true' ||
  process.env.GITLAB_CI === 'true' ||
  process.env.BITBUCKET_BUILD_NUMBER !== undefined;

export const envLocale = process.env.NEXT_PUBLIC_LOCALE;

export const isBuildPhase = process.env.NEXT_PHASE === 'phase-production-build';

export const cmsApiEndpoint = (() => {
  if (isBuildPhase) {
    return process.env.STRAPI_API_URL; // Used for client side calls to CMS - to avoid exposing the URL
  }
  if (typeof window !== 'undefined') {
    return process.env.NEXT_PUBLIC_STRAPI_API_URL; // Used for client side calls to CMS - to avoid exposing the URL
  }
  return process.env.INTERNAL_STRAPI_API_URL; // Used for SSR componnts - calls CMS container directly (faster)
})();

export const nextApiEndpoint = (() => {
  if (isDev) {
    return 'http://localhost:3000/next-api';
  }
  if (envLocale === 'zh-cn') {
    return `${process.env.NEXT_PUBLIC_DOMAIN}/next-api`;
  }
  return `http://decodo-website-nginx:8088/next-api`;
})();
